// Web ordering kill switch for the public venue page (/venues/:bizId).
//
// OFF (Nov 2026) until:
//  - the web QR order endpoint stops trusting prices sent by the browser (F33), and
//  - Square option handling in DishModal is fixed (G1: `enabled` means "selected").
// While off, venues show "Order through the Piatto app" with store links instead
// of the cart. Note this only hides the web UI; the order endpoint itself is
// unchanged.
export const WEB_ORDERING_ENABLED = false;

export const APP_STORE_URL =
  "https://apps.apple.com/au/app/piatto-order-ahead-for-all/id1602642481";
export const GOOGLE_PLAY_URL =
  "https://play.google.com/store/apps/details?id=com.cubage.winndine&hl=en_AU";

/**
 * Link that opens the venue in the Piatto app (universal link / app link).
 * Uses the venue's `bizId` field when present (the key the app looks venues
 * up by), else the doc ID, and keeps ?tableNo so the app pre-fills the table.
 *
 * Only https://piatto.com.au/venues/… works: the app's piatto:// scheme
 * doesn't reach the venue screen (its path parser expects a leading slash).
 */
export function appVenueLink(venue, docId, tableNo) {
  const appId =
    (typeof venue?.bizId === "string" && venue.bizId.trim()) ||
    (typeof venue?.bizId === "number" ? String(venue.bizId) : "") ||
    docId;
  const query = tableNo ? `?tableNo=${encodeURIComponent(tableNo)}` : "";
  return `https://piatto.com.au/venues/${encodeURIComponent(appId)}${query}`;
}

/**
 * A venue is taking orders through Piatto only if it can take payments:
 * a Stripe account (bizStripeId) AND charges enabled (stripeChargesEnabled,
 * written by the Stripe account webhook / onboarding).
 *
 * Deliberately stricter than the app (useVenueCapabilities), which also
 * counts POS canSubmitOrders or a bizStripeId alone: e.g. Lumen has Square
 * canSubmitOrders but no Stripe account, so it can't actually take an order.
 */
export const canTakePayments = (venue) =>
  typeof venue?.bizStripeId === "string" &&
  venue.bizStripeId.trim() !== "" &&
  venue?.stripeChargesEnabled === true;
